import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderCreate from '../../views/multiChannel/OrderCreate';
import { MULTI_CHANNEL_PAGE_NAME } from '../../constants/service/app/multiChannelConstants';

const MultiChannelOrderCreate = () => {
  return (
    <PageTemplate pageName={MULTI_CHANNEL_PAGE_NAME.ORDER_CREATE}>
      <OrderCreate />
    </PageTemplate>
  );
};

export default MultiChannelOrderCreate;
